import { useData, ADMIN_TABLE } from "../../context/DataContext";
import TaskTable from "../../components/TaskTable";
import { STATUS_OPTIONS } from "../../utils/helpers";

export default function AllTasksAdmin() {
  const { adminRecords, loading } = useData();
  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>📋 All Tasks</h1>
        <p>Full task list — you can edit or delete any record</p>
      </div>
      <TaskTable
        records={adminRecords}
        tableId={ADMIN_TABLE}
        canEdit
        canDelete
        emptyMsg="No tasks found."
        statusOptionsOverride={STATUS_OPTIONS}
      />
    </div>
  );
}
